<template>
  <div class="contacts-departments">
    <slot name="title">
      <h4 class="mb-20">Обратная связь</h4>
    </slot>
    <div class="contacts-departments-wrapper">
      <contacts-department
        v-for="(item, index) in items"
        :key="index"
        :icon="item.icon"
        :phones="item.phones"
        :emails="item.emails"
        :btn-title="item.btnTitle"
        @click="openVzFeedbackMessageModal(item.code)"
      />
    </div>
    <vz-feedback-message-modal
      ref="feedbackMessage"
      :department-code="activeCode"
      :init-guid="activeGuid"
      @clear-open-modal-params="onClear"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { getContactsInfo } from '~~/api/contacts'
import { useCityStore } from '~~/stores/city'
import ContactsDepartment from '~/components/public/contacts/contacts-department.vue'
import VzFeedbackMessageModal from '~/components/modals/vz-feedback-message-modal.vue'

const props = defineProps({
  location: {
    type: String,
    default: ''
  },
  isShort: {
    type: Boolean,
    default: false
  }
})

const route = useRoute()

const { $showDialog } = useNuxtApp()
const { currentCity } = storeToRefs(useCityStore())

const activeCode = ref('')
const activeGuid = ref('')
const departments = await getContactsInfo(props.location || currentCity.value?.translit || '')

const items = computed(() => {
  const d = [
    {
      code: 'clientQuestion',
      icon: '/svg/balloon-sms.svg',
      phones: departments.dep_client?.phones,
      btnTitle: 'Я ваш клиент - есть вопрос'
    },
    {
      code: 'becomeAClient',
      icon: '/svg/vz-signature.svg',
      phones: departments.dep_sale?.phones,
      emails: departments.dep_sale?.emails,
      btnTitle: 'Стать клиентом'
    },
    {
      code: 'employment',
      icon: '/svg/hands.svg',
      btnTitle: 'Работа в компании'
    },
    {
      code: 'partnership',
      icon: '/svg/vz-suitcase.svg',
      btnTitle: 'Стать партнером'
    } 
  ]

  return props.isShort ? d.slice(0, 2) : d
})

function openVzFeedbackMessageModal(code: string, guid?: string): void {
  activeCode.value = code
  if (guid?.length) {
    activeGuid.value = guid 
  }
  $showDialog({ name: 'feedback-message' })
}

function onClear() {
  activeGuid.value = ''
}

onMounted(() => {
  if (route.query?.openModalCode && route.query?.openModalGuid) {
    openVzFeedbackMessageModal(route.query?.openModalCode.toString(), route.query?.openModalGuid.toString())
  }
})
</script>
